var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({class:{
    'px-3 rounded h-5 cursor-pointer font-medium relative': true,
    'smart-button smart-button--default align-center': true,
    'smart-button--loading': _vm.loading,
    'smart-button--secondary': _vm.secondary,
    'smart-button--tertiary': _vm.tertiary,
    'smart-button--quaternary': _vm.quaternary,
    'smart-button--quinary': _vm.quinary,
    'smart-button--sextenary': _vm.sextenary,
    'smart-button--box': _vm.box,
    'smart-button--text': _vm.text,
    'cursor-not-allowed text-opacity-md': _vm.isDisabledOrLoading,
    'smart-button--iconed': _vm.icon
  },attrs:{"id":_vm.getInputId(),"disabled":_vm.isDisabledOrLoading,"role":"button"}},_vm.listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }